import { render, staticRenderFns } from "./PaymentAmount.vue?vue&type=template&id=138eeb95&scoped=true&"
import script from "./PaymentAmount.vue?vue&type=script&lang=js&"
export * from "./PaymentAmount.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAmount.vue?vue&type=style&index=0&id=138eeb95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138eeb95",
  null
  
)

export default component.exports